import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

export default function PasswordField({
    name = "password",
    value,
    onChange,
    placeholder,
    disabled,
    error,
    helperText,
    size = 'small'
}) {
    const [show, setShow] = useState(false);

    return (
        <TextField
            name={name}
            type={show ? 'text' : 'password'}
            value={value || ''}
            onChange={onChange}
            placeholder={placeholder}
            disabled={disabled}
            error={!!error}
            size={size}
            fullWidth
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            edge="end"
                            onClick={() => setShow(s => !s)}
                            onMouseDown={(e) => e.preventDefault()}
                            aria-label={show ? 'Hide password' : 'Show password'}
                        >
                            {show ? <VisibilityOff /> : <Visibility/>}
                        </IconButton>
                    </InputAdornment>
                )
            }}
        />
    )
}